
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93EPLAEwSaldMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93kSDy8eXTYgMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/blogg/[...slug].vue?macro=true";
import { default as indexxR6oyeGlpeMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/blogg/index.vue?macro=true";
import { default as indexck5EDGcU2nMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/checkout/index.vue?macro=true";
import { default as paymentkyARQrlbnMMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/checkout/payment.vue?macro=true";
import { default as index_46clientR1ZMeCl4PqMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/checkout/thank-you/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexoxAPMUKdgEMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/collections/index.vue?macro=true";
import { default as _91slug_9335AzLG6fa4Meta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/faq/[slug].vue?macro=true";
import { default as indexCmUr2GsIkTMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/hillceramic-rabattkoder/index.vue?macro=true";
import { default as indexJIMdld96SSMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/index.vue?macro=true";
import { default as indexFDcfnCXtAyMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/login/index.vue?macro=true";
import { default as _91id_93RfImE8J4zaMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/qr-pr/[id].vue?macro=true";
import { default as form93V6CeyMq6Meta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/review/form.vue?macro=true";
import { default as indexeZD3DvOlkZMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/review/index.vue?macro=true";
import { default as _91_46_46_46slug_93gotROAXFLCMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/shop/[...slug].vue?macro=true";
import { default as indexLiTmONuVt2Meta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/track/index.vue?macro=true";
export default [
  {
    name: "slug___da",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93EPLAEwSaldMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/[...slug].vue")
  },
  {
    name: "blogg-slug___da",
    path: "/blogg/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/blogg/[...slug].vue")
  },
  {
    name: "blogg___da",
    path: "/blogg",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/blogg/index.vue")
  },
  {
    name: "checkout___da",
    path: "/checkout",
    meta: indexck5EDGcU2nMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment___da",
    path: "/checkout/payment",
    meta: paymentkyARQrlbnMMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/checkout/payment.vue")
  },
  {
    name: "checkout-thank-you___da",
    path: "/checkout/thank-you",
    meta: index_46clientR1ZMeCl4PqMeta || {},
    component: () => createClientPage(() => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/checkout/thank-you/index.client.vue"))
  },
  {
    name: "collections___da",
    path: "/samlinger",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/collections/index.vue")
  },
  {
    name: "faq-slug___da",
    path: "/faq/:slug()",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/faq/[slug].vue")
  },
  {
    name: "hillceramic-rabattkoder___da",
    path: "/hillceramic-rabattkoder",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/hillceramic-rabattkoder/index.vue")
  },
  {
    name: "index___da",
    path: "/",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/index.vue")
  },
  {
    name: "login___da",
    path: "/login",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/login/index.vue")
  },
  {
    name: "qr-pr-id___da",
    path: "/qr-pr/:id()",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/qr-pr/[id].vue")
  },
  {
    name: "review-form___da",
    path: "/review/form",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/review/form.vue")
  },
  {
    name: "review___da",
    path: "/review",
    meta: indexeZD3DvOlkZMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/review/index.vue")
  },
  {
    name: "shop-slug___da",
    path: "/shop/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/shop/[...slug].vue")
  },
  {
    name: "track___da",
    path: "/track",
    meta: indexLiTmONuVt2Meta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/pages/track/index.vue")
  }
]